const formSubmission = require('../lib/formSubmission');

window.addEventListener('load', function() {

    const permissionsForm = document.getElementById('frm-permissions');
    if (permissionsForm) {
        const inputElements = permissionsForm.getElementsByTagName('input');
        for (let i = 0; i < inputElements.length; i++) {
            const inputElement = inputElements[i];
            if (inputElement.type === 'radio') {
                inputElement.addEventListener('click', sendPermission);
            }
        }
    }

    const stateForm = document.getElementById('frm-state');
    if (stateForm) {
        const inputElements = stateForm.getElementsByTagName('input');
        for (let i = 0; i < inputElements.length; i++) {
            const inputElement = inputElements[i];
            if (inputElement.type === 'radio') {
                inputElement.addEventListener('click', sendState);
            }
        }
    }

    const participateForm = document.getElementById('frm-participate');
    if (participateForm) {
        const inputElements = participateForm.getElementsByTagName('input');
        inputElements[0].addEventListener('click', sendParticipation);
    }

    const eventCopyForm = document.getElementById('frm-eventcopy');
    if (eventCopyForm) {
        const inputElements = eventCopyForm.getElementsByTagName('input');
        inputElements[0].addEventListener('click', sendEventCopy);
    }

});

function sendPermission(radioButton) {

    const form = document.getElementById('frm-permissions');

    const permissionName = radioButton.target.name;
    const outcome = radioButton.target.value;

    const formData = new FormData();
    formData.append('granted', outcome);

    const url = form.getAttribute('action') + '/' + permissionName;
    const submissionControl = radioButton;
    const notificationControl = form.getElementsByClassName('notification')[0];
    const success = function () {
        location.reload(true);
        return null;
    };

    formSubmission.submitFormData(formData, url, submissionControl, notificationControl, success);

}

function sendState(radioButton) {

    const form = document.getElementById('frm-state');

    const state = radioButton.target.value;

    const formData = new FormData();
    formData.append('state', state);

    const url = form.getAttribute('action');
    const submissionControl = radioButton;
    const notificationControl = form.getElementsByClassName('notification')[0];
    const success = function () {
        location.reload(true);
        return null;
    };

    formSubmission.submitFormData(formData, url, submissionControl, notificationControl, success);

}

function sendParticipation(button) {

    const form = document.getElementById('frm-participate');

    const formData = new FormData();

    const url = form.dataset['action'];
    const submissionControl = button;
    const notificationControl = form.getElementsByClassName('notification')[0];

    const success = function () {
        const content = document.getElementById('data-event-info');
        content.outerHTML = '<section class="message centered"><div class="message-title">Gratulation</div><p class="message-content">Du nimmst nun an dem Turnier teil und kannst deine <a href="myresults">Resultate erfassen</a>. Wir wÃ¼nschen dir viel Spass und Erfolg.</p></section>';
        return null;
    };

    formSubmission.submitFormData(formData, url, submissionControl, notificationControl, success);

}

function sendEventCopy(button) {

    const form = document.getElementById('frm-eventcopy');

    const formData = new FormData();

    const url = form.dataset['action'];
    const submissionControl = button;
    const notificationControl = form.getElementsByClassName('notification')[0];

    const success = function (response) {
        const newEventId = String(response);
        window.location.assign(window.location.origin + '/events/' + newEventId + '/info');
        return null;
    };

    formSubmission.submitFormData(formData, url, submissionControl, notificationControl, success);

}

